class DammiHeader extends HTMLElement {
  connectedCallback() {
    const isHomePage = this.getAttribute("home") === "true";
    const homeLink = isHomePage ? "#" : "index.html";

    this.innerHTML = `
      <header class="fixed w-full z-50 bg-white/90 backdrop-blur-md border-b border-slate-200 transition-all duration-300" id="navbar">
        <div class="container mx-auto px-6 py-4 flex justify-between items-center">
          <a href="${homeLink}" class="flex items-center gap-2 group">
            <img src="assets/dammi-logo.svg" alt="DAMMI.LV Logo" class="h-8">
          </a>

          <!-- Desktop Navigation -->
          <nav class="hidden md:flex items-center gap-6">
            ${
      isHomePage
        ? `
              <a href="checklist.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="Self Assessment" data-lv="Pašnovērtējums" data-it="Autovalutazione">Self Assessment</a>
              <a href="offers.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="Offers" data-lv="Piedāvājumi" data-it="Offerte">Offers</a>
              <a href="showcase.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="Showcase" data-lv="Demonstrējums" data-it="Showcase">Showcase</a>
              <a href="#contact" class="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-all shadow-md hover:shadow-lg" data-en="Contact Us" data-lv="Sazināties" data-it="Contattaci">Contact Us</a>
            `
        : `
              <a href="index.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="About us" data-lv="Par mums" data-it="Chi siamo">About us</a>
              <a href="checklist.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="Self Assessment" data-lv="Pašnovērtējums" data-it="Autovalutazione">Self Assessment</a>
              <a href="offers.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="Offers" data-lv="Piedāvājumi" data-it="Offerte">Offers</a>
              <a href="showcase.html" class="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-en="Showcase" data-lv="Demonstrējums" data-it="Showcase">Showcase</a>
              <a href="index.html#contact" class="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-all shadow-md hover:shadow-lg" data-en="Contact Us" data-lv="Sazināties" data-it="Contattaci">Contact Us</a>
            `
    }
          </nav>

          <!-- Auth Button -->
          <button type="button" id="kinde-auth-btn"
            class="hidden border border-slate-300 text-slate-600 hover:text-slate-900 hover:border-slate-400 px-4 py-2 rounded-lg text-sm font-medium transition-all">
            <span class="kinde-login-text" data-en="Login" data-lv="Ieiet" data-it="Accedi">Login</span>
            <span class="kinde-logout-text hidden" data-en="Logout" data-lv="Iziet" data-it="Esci">Logout</span>
          </button>

          <!-- Language Switcher -->
          <dammi-lang-switcher></dammi-lang-switcher>

          <!-- Mobile Menu Button -->
          <button id="mobile-menu-btn" class="md:hidden text-slate-600 hover:text-slate-900 focus:outline-none">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>

        <!-- Mobile Menu -->
        <div id="mobile-menu" class="hidden md:hidden bg-white border-t border-slate-100 absolute w-full">
          <div class="flex flex-col p-4 space-y-4">
            ${
      isHomePage
        ? `
              <a href="#about" class="text-slate-600 font-medium" data-en="About us" data-lv="Par mums" data-it="Chi siamo">About us</a>
              <a href="checklist.html" class="text-slate-600 font-medium" data-en="Self Assessment" data-lv="Pašnovērtējums" data-it="Autovalutazione">Self Assessment</a>
              <a href="offers.html" class="text-slate-600 font-medium" data-en="Offers" data-lv="Piedāvājumi" data-it="Offerte">Offers</a>
              <a href="showcase.html" class="text-slate-600 font-medium" data-en="Showcase" data-lv="Demonstrējums" data-it="Showcase">Showcase</a>
              <a href="#contact" class="text-indigo-600 font-medium" data-en="Contact Us" data-lv="Sazināties" data-it="Contattaci">Contact Us</a>
            `
        : `
              <a href="index.html#about" class="text-slate-600 font-medium" data-en="About us" data-lv="Par mums" data-it="Chi siamo">About us</a>
              <a href="checklist.html" class="text-slate-600 font-medium" data-en="Self Assessment" data-lv="Pašnovērtējums" data-it="Autovalutazione">Self Assessment</a>
              <a href="offers.html" class="text-slate-600 font-medium" data-en="Offers" data-lv="Piedāvājumi" data-it="Offerte">Offers</a>
              <a href="showcase.html" class="text-slate-600 font-medium" data-en="Showcase" data-lv="Demonstrējums" data-it="Showcase">Showcase</a>
              <a href="index.html#contact" class="text-indigo-600 font-medium" data-en="Contact Us" data-lv="Sazināties" data-it="Contattaci">Contact Us</a>
            `
    }
            <button type="button" id="kinde-auth-btn-mobile"
              class="hidden text-left text-slate-600 font-medium pt-1 border-t border-slate-100">
              <span class="kinde-login-text" data-en="Login" data-lv="Ieiet" data-it="Accedi">Login</span>
              <span class="kinde-logout-text hidden" data-en="Logout" data-lv="Iziet" data-it="Esci">Logout</span>
            </button>
          </div>
        </div>
      </header>
    `;

    // Mobile menu toggle
    const mobileMenuBtn = this.querySelector("#mobile-menu-btn");
    const mobileMenu = this.querySelector("#mobile-menu");

    mobileMenuBtn?.addEventListener("click", () => {
      mobileMenu?.classList.toggle("hidden");
    });
  }
}

customElements.define("dammi-header", DammiHeader);
